import axios from 'axios';
import { awsUrl, url } from '../../axiosInstance';
import * as actionType from '../store/action';
import showAlert from '../server/ShowAlert';

export const AddNewSalesPost = ( data) => {
    return axios.post(`${awsUrl}/v1/sales`,
        data, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
        },
    })
}

export const UpdateStationToSalePost = ( data) => {
    return axios.post(`${awsUrl}/v1/sales/station`,
        data, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
        },
    })
}

export const UpdateProductToSalePost = ( data) => {
    return axios.post(`${awsUrl}/v1/sales/product`,
        data, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
        },
    })
}


export const DeleteSale = ( saleId ) => {
    return axios.post(`${awsUrl}/v1/sales/delete/${saleId}`,{}, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
        }
    })
}

export const GetSalesList = () => {
    return axios.get(`${awsUrl}/v1/sales`, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
        },
    })
}

export const GetProductList = (saleId) => {
    return axios.get(`${awsUrl}/v1/sales/product?saleId=${saleId}`, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
        },
    })
}

export const GetStationList = (saleId) => {
    return axios.get(`${awsUrl}/v1/sales/station?saleId=${saleId}`, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
        },
    })
}